import { createLoadingType } from "../actionHelpers";

export const APP_LOADING = createLoadingType("APP_LOADING");
export const ADD_LOADER = createLoadingType("ADD_LOADER");
export const REMOVE_LOADER = createLoadingType("REMOVE_LOADER");
